import React from 'react';
import css from './BlueLayout.module.css';
import {
  G2BadgeTop50,
  MetaBadge,
  RefreshArrowIcon,
  SignatureIcon,
  TeamIcon,
} from '@mm/icons';
import { Iconiq } from './Iconiq';
import { Inc500 } from './Inc500';
import { ProductWeek } from './ProductWeek';
import { ProductDay } from './ProductDay';
import { ProductHunt } from './ProductHunt';
import classNames from 'classnames';

export const SignUpLikeLayout = ({ hideTrial }) => (
  <div
    className={classNames(css.headlineContainer, css.signUpHeadlineContainer)}
  >
    {!hideTrial && (
      <div className={css.card}>
        <span className={css.cardHeading}>
          <div className={css.tag}>Free Trial</div> No credit card required.
        </span>
        <span className={css.attention}>
          Get started with 500 website visitor contacts FREE!
        </span>
      </div>
    )}

    <div className={css.headline}>
      <span>
        Start capturing your website visitor info.
        <br /> Supercharge your marketing.
      </span>
    </div>

    <ul className={css.list}>
      <li className={css.listElement}>
        <figure>
          <SignatureIcon />
        </figure>
        <span>Send AI-personalized email follow-ups</span>
      </li>

      <li className={css.listElement}>
        <figure>
          <TeamIcon />
        </figure>
        <span>Create enriched B2C and B2B visitor profiles</span>
      </li>

      <li className={css.listElement}>
        <figure>
          <RefreshArrowIcon />
        </figure>
        <span>
          Restore ad retargeting audiences affected by Google and Apple cookie
          and script deletion
        </span>
      </li>
    </ul>

    <div className={css.rows}>
      <div className={css.row}>
        <G2BadgeTop50 />
        <Iconiq />
        <MetaBadge className={css.badge} />
        <Inc500 />
      </div>
      <div className={css.row}>
        <ProductDay />
        <ProductWeek />
        <ProductHunt />
      </div>
    </div>
  </div>
);
